/**
 * This routes must be disappear as well as each product migrates to new frontend.
 */
export enum ProductDetailRoutes {
    HEALTH = "/v1/#/salud/:productCode/detalle-poliza/:systemCode/:policyId",
    VEHICLES = "/v1/#/autos/:productCode/detalle-poliza/:systemCode/:policyId",
    SOAT = "/v1/#/soat/:productCode/detalle-poliza/:systemCode/:policyId",
    // PGA policies
    TRAVELS = "/v1/#/pga/viajes/:productCode/detalle-poliza/:systemCode/:policyId",
    MORTGATE = "/v1/#/pga/hipotecario/:productCode/detalle-poliza/:systemCode/:policyId",
    ACCIDENTES = "/V1/#/pga/accidentes/:productCode/detalle-poliza/:systemCode/:policyId",
}
